import LogoUploaderForm from './LogoUploaderForm';

export default LogoUploaderForm;
